/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiApp } from 'api/request';
import urlApp from 'api/urlApp';
import { size } from 'lodash';
import HttpRequestError from 'utils/HttpRequetsError';

export async function getInfoCustomerApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getInfoCustomerPath);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function requestOtpPhoneExistApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.requestOtpCustomerPhoneExistPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function requestOtpNewPhoneApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.requestOtpCustomerPhoneNewPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function verifyOtpApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.verifyOtpPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function updateInfoCustomerApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.updateInfoCustomerPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}